<template>
  <v-menu offset-y bottom>
    <template v-slot:activator="{ on }">
      <v-btn flat v-on="on">
        Create
        <v-icon>arrow_drop_down</v-icon>
        <!-- span>Create / Order A Brand-New Item</span -->
      </v-btn>
    </template>

    <v-list>
      <template v-if="hasPrivate">
        <v-list-tile v-for="product in privateProducts"
                     :key="product.id"
                     :to="`/create/${product.id}`"
        >
          {{product.name}}
        </v-list-tile>
        <v-divider/>
      </template>
      <v-list-tile v-for="product in publicProducts"
                   :key="product.id"
                   :to="`/create/${product.id}`"
      >
        {{product.name}}
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    computed: {
      products () {
        return this.$store.state.products
      },

      privateProducts () {
        let ret = []
        for (let index in this.products) {
          if (this.products[index].private) ret.push(this.products[index])
        }
        return ret
      },

      publicProducts () {
        let ret = []
        for (let index in this.products) {
          if (!this.products[index].private) ret.push(this.products[index])
        }
        return ret
      },

      hasPrivate () {
        if (this.privateProducts.length > 0) {
          return true
        }

        return false
      }
    },

    beforeMount () {
      this.$store.dispatch('loadProducts')
    },

    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// create-menu.vue?e6549f4e